// extracted by mini-css-extract-plugin
export default {"container":"dashboard-stage_container__Wee0s","title":"dashboard-stage_title__7xFuf","entries":"dashboard-stage_entries__Q12bp"};